export default __webpack_public_path__ + "static/media/medical_4.53122cfc.jpg";